import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, LocaleX, ReqX, ZMath, ZTime } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, VStack, XButton, XText } from "IZOX/_X";
import _ from "lodash";
import QUICKUI from "shared/QUICKUI";
import ReceiptUtils from "shared/_utils/ReceiptUtils";
import PAPopupReceipts from "./PAPopupReceipts";
import { PageFlipper } from "IZOX/BLOCKS/Libs";

/**
 * @augments {Component<Props, State>}
 */
class PAReceipt extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      docs: [],
      page: 0,
      pageSize: 5
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.GetReceipts();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PAReceipt.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  onPageChange = (page) => {
    this.setState({
      page: page
    }, () => {
      this.ReloadAll();
    });
  }
  
  onPageSizeChange = (pageSize) => {
    this.setState({
      pageSize: pageSize
    }, () => {
      this.ReloadAll();
    });
  }

  ReloadAll = () => {
    this.GetReceipts();
  }

  GetReceipts = async () => {
    let {page, pageSize} = this.state;
    let res = await ReqX.SendBE("/Web/Agent/GetRecentReceipts", {
      page: page,
      pageSize: pageSize
    });
    let {Success, payload} = res;
    if(Success){
      let {docs, count} = payload;
      this.setState({
        docs: docs,
        count: count
      });
    }
  }

  _toDoc = (_id) => {

  }

  _toPopupReceipts = async (_id) => {
    let {docs} = this.state;
    let receiptDoc = _.find(docs, o => o._id === _id);

    let res = await ReqX.SendBE("/Web/Agent/ViewPolicy", {
      docID: receiptDoc.policyID
    });
    let {Success, payload} = res;
    if(Success){
      let {policyDoc, receiptDocs} = payload;
      GFunc.Backdrop(() => {
        return (
          <PAPopupReceipts policyDoc={policyDoc} receiptDocs={receiptDocs} refresh={this.ReloadAll}/>
        );
      }, {}, false);
    }
  }

  renderRemark(){
    return (
      <HStack bColor={ColorX.CSS("Stone")} bW={1} p={8} 
        bgColor={ColorX.CSS("pureWhite")}
        HAlign="[">
        <XText fullWidth fontSize={10}>
          {LocaleX.Parse({
            EN: "Remark: Please note that the dashboard data has a one-day delay.",
            TC: "備註：請注意概覽資料有一天的延遲。"
          })}
        </XText>
      </HStack>
    );
  }

  renderReceiptNo(receiptNo){
    return (
      <HStack HAlign="[" spacing={5}>
        <XText color={ColorX.CSS("Leaf")} fontSize={14}>
          {LocaleX.Parse({
            EN: "Receipt no.",
            TC: "收據編號"
          })}
        </XText>
        <XText color={ColorX.CSS("Leaf")} bold>
          {receiptNo}
        </XText>
      </HStack>
    );
  }

  renderVertBox(label, value, style){
    return (
      <VStack fullWidth>
        <HStack HAlign="[">
          <XText color={ColorX.CSS("Gray4")} fullWidth
            fontSize={12}>
            {LocaleX.Parse(label)}
          </XText>
        </HStack>
        <HStack HAlign="[">
          <XText color={ColorX.CSS("Stone")} fontSize={14}
            style={style} fullWidth>
            {LocaleX.Parse(value)}
          </XText>
        </HStack>
      </VStack>
    );
  }

  renderReceiptDoc(doc, idx){
    let {_id, policyID, policyNo, status, uploadAt, amount, remark} = doc;
    let _status = ReceiptUtils.GetStatus(status);
    return (
      <XButton onPress={() => this._toPopupReceipts(_id)} key={idx} fullWidth
        hoverMode="none"
        notInjectColor bgColor={ColorX.CSS("pureWhite")}
        style={{boxShadow: `2px 1px 1px 1px ${ColorX.CSS("greyOut", 0.3)}`}}
        round={0} mB={16} padding={16}>
        <VStack fullWidth spacing={5}>
          {this.renderReceiptNo(policyNo ?? _id)}
          <HStack spacing={10}>
            {this.renderVertBox({
              EN: "Status",
              TC: "狀態"
            }, _status?.label, {
              color: _status?.color, 
              backgroundColor: _status?.bgColor,
              textAlign: "center",
              marginRight: 40
            })}
            {this.renderVertBox({
              EN: "Ref no.",
              TC: "參考編號"
            }, policyID)}
            {this.renderVertBox({
              EN: "Upload date",
              TC: "上傳日期"
            }, ZTime.Moment(uploadAt).format("DD/MM/YYYY"))}
            {this.renderVertBox({
              EN: "Amount",
              TC: "金額"
            }, "HK$ " +  ZMath.NumberWithCommas(amount))}
          </HStack>
          <VStack fullWidth>
            <HStack HAlign="[">
              <XText color={ColorX.CSS("Gray4")} fullWidth
                fontSize={12}>
                {LocaleX.Parse({
                  EN: "Remark",
                  TC: "備註"
                })}
              </XText>
            </HStack>
            <HStack>
              <XText color={ColorX.CSS("Stone")} fontSize={14}
                fullWidth>
                {LocaleX.Parse(remark)}
              </XText>
            </HStack>
          </VStack>
        </VStack>
      </XButton>
    );
  }

  renderDocs(){
    let {docs, count, page, pageSize} = this.state;

    if(_.isEmpty(docs)){
      return QUICKUI.NoDocs({
        EN: "There is no past receipt uploaded records within 3 months.",
        TC: "3個月內沒有過往收據上傳記錄。"
      });
    }

    return (
      <VStack fullWidth pV={24}>
        {_.map(docs, (o, i) => {
          return this.renderReceiptDoc(o, i);
        })}
        <PageFlipper totalDocs={count} 
          page={page}
          pageSize={pageSize}
          onPageSizeChange={this.onPageSizeChange}
          onPageChange={this.onPageChange}
          mainColor={ColorX.CSS("Axit")} />
      </VStack>
    );
  }

  render(){
    return (
      <VStack fullWidth bgColor={ColorX.CSS("NotQuiteWhite")} p={18}>
        {this.renderRemark()}
        {this.renderDocs()}
      </VStack>
    );
  }

}

export default observer(PAReceipt);
